import { Anchor, Badge, Group, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { motion } from 'motion/react';

import CogniteLogo from '#core/assets/cognite-logo-icon.svg?react';

import classes from './AtlasAiTitle.module.css';
import { itemTransition } from './transitions.ts';

export interface AtlasAiTitleProps {
  title?: string;
  subtitle?: string;
  disclaimerUrl?: string;
}

/** Hero title component for the Atlas AI chat interface with branding and disclaimer. */
export function AtlasAiTitle({
  // TODO: Read defaults from chat/Agent context
  title = 'AiPSO AI Advisor',
  subtitle = 'Powered by Cognite Atlas AI™',
  disclaimerUrl = '.',
}: AtlasAiTitleProps) {
  return (
    <motion.div className={classes.title} variants={itemTransition}>
      {title && (
        <Text c="white" className={classes.titleText} fw={700} size="2.6rem">
          {title}
        </Text>
      )}

      {subtitle && (
        <Badge
          gradient={{ from: 'grape', to: 'violet', deg: 120 }}
          leftSection={<CogniteLogo fill="white" height={24} width={24} />}
          size="xl"
          tt="initial"
          variant="gradient"
        >
          {subtitle}
        </Badge>
      )}
      {disclaimerUrl && (
        <Text c="dark.2" component="div" size="xs">
          <Group gap="xs">
            <IconInfoCircle size={16} />
            <Group gap="xs">
              AI responses may be inaccurate or misleading.
              <Anchor component={Link} to={disclaimerUrl}>
                Learn more
              </Anchor>
            </Group>
          </Group>
        </Text>
      )}
    </motion.div>
  );
}
